<a class="default m-6.25 group flex h-[110px] w-[165px] flex-col items-center justify-between rounded-lg border-2 border-transparent bg-widget no-underline hover:border-blue-500 hover:text-blue-500"
        rel="noreferrer" target="_blank">
        <div class="inline-flex h-14 items-end justify-center gap-2.5">
                <bizz-icon class="relative h-8 w-8" [iconLibrary]="icon.Library" [iconName]="icon.Name"></bizz-icon>
        </div>
        <span
                class="inline-flex h-[49px] w-[165px] items-center justify-center gap-2.5 px-2.5 pb-[5px] text-center text-sm text-button group-hover:text-blue-500">{{caption
                }}</span>
</a>